import { Controller } from "@hotwired/stimulus"

// 活動目標達成のアドバイスモーダルの表示制御（UC-027）
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    if (this.dialogTarget.open) {
      this.dialogTarget.close()
    }
    this.dialogTarget.classList.add("hidden")
  }

  open() {
    if (this.dialogTarget.open) return

    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.showModal()
  }

  close() {
    if (!this.dialogTarget.open) return

    this.dialogTarget.close()
    this.dialogTarget.classList.add("hidden")
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  handleCancel(event) {
    event.preventDefault()
    this.close()
  }

  syncVisibility() {
    if (!this.dialogTarget.open) {
      this.dialogTarget.classList.add("hidden")
    }
  }
}
